import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TabNotificationSoundService {
  private readonly storageKey = 'notification-sound-muted';
  private readonly mutedSubject = new BehaviorSubject<boolean>(
    this.readMutedState(),
  );

  readonly muted$ = this.mutedSubject.asObservable();

  get isMuted(): boolean {
    return this.mutedSubject.value;
  }

  toggle(): boolean {
    const muted = !this.isMuted;
    this.mutedSubject.next(muted);

    try {
      sessionStorage.setItem(this.storageKey, String(muted));
    } catch {
      // The in-memory state still works when browser storage is unavailable.
    }

    return muted;
  }

  private readMutedState(): boolean {
    try {
      return sessionStorage.getItem(this.storageKey) === 'true';
    } catch {
      return false;
    }
  }
}
